import { Loading, QueryError } from "../../../../components/Loading/Loading";
import Select, { type MultiValue, type SingleValue } from "react-select";
import { useFamilias } from "../../../../hooks/Api/Familias";


interface FiltroKitsProps {
	readonly familia: string[];
	readonly setFamilia: (value: string[]) => void;
	readonly kit: boolean | null;
	readonly setKit: (value: boolean | null) => void;
}
export function FiltroKits(props: FiltroKitsProps) {
	const { data, error, isPending } = useFamilias();
	const optionsKit = [
		{ value: null, label: "Todos" },
		{ value: true, label: "Con Kit" },
		{ value: false, label: "Sin Kit" }
	];

	if (error) return <QueryError error={error} fallback="Error al cargar las familias" />;
	if (isPending) return <Loading />;

	const onChangeFam = (newValue: MultiValue<{ value: string; label: string; }>) => {
		const selectedIds = newValue.map((option) => option.value);
		props.setFamilia(selectedIds);
	};
	const onChangeKit = (newValue: SingleValue<{ value: boolean | null; label: string; }>) => {
		props.setKit(newValue?.value ?? null);
	};

	const familiaValue = data.filter(fam => props.familia.includes(fam.idFamilia)).map(fam => ({ value: fam.idFamilia, label: fam.nombreFamilia }));
	const kitValue = optionsKit.find(opt => opt.value === props.kit);
	return (
		<div className="inputContainerGrid" role="tabpanel" style={{ padding: 30 }} >
			<label>Familias: </label>
			<Select
				options={data.map((fam) => ({ value: fam.idFamilia, label: fam.nombreFamilia }))}
				isMulti
				className=""
				value={familiaValue}
				onChange={onChangeFam}
			/>

			<label>Kit: </label>
			<Select
				options={optionsKit}
				className=""
				value={kitValue}
				onChange={onChangeKit}
			/>
		</div>
	);
}